import { DataAggregation } from '../../dataModel';
import { DataType } from '../../dataModel/DataType';

export class Value {
  constructor(
    public readonly value: any,
    public readonly type: DataType,
    public readonly isAggregated: boolean,
    public readonly aggregation: DataAggregation | null) { }
}
